import type { SVGProps } from "react";

import * as Icons from "@interstate/components/Icons";
export { ViewColumnsIcon } from "@interstate/components/Icons/ViewColumnsIcon";

export interface SvgProps {
  title: string;
  titleId?: string;
  desc?: string;
  descId?: string;
  "data-testid"?: string;
}
type SvgIconProps = SVGProps<SVGSVGElement> & SvgProps;

type iconProps = React.ForwardRefExoticComponent<
  Omit<SvgIconProps, "ref"> & React.RefAttributes<SVGSVGElement>
>;

export const XMarkIcon = Icons.XMarkIcon as iconProps;
export const InformationCircleIcon = Icons.InformationCircleIcon as iconProps;
export const BellIcon = Icons.BellIcon as iconProps;
export const XCircleIcon = Icons.XCircleIcon as iconProps;
export const WrenchIcon = Icons.WrenchIcon as iconProps;
export const WifiIcon = Icons.WifiIcon as iconProps;
export const VideoCameraIcon = Icons.VideoCameraIcon as iconProps;
export const UsersIcon = Icons.UsersIcon as iconProps;
export const UserIcon = Icons.UserIcon as iconProps;
export const UserPlusIcon = Icons.UserPlusIcon as iconProps;
export const UserCircleIcon = Icons.UserCircleIcon as iconProps;
export const UnlinkIcon = Icons.UnlinkIcon as iconProps;
export const TruckIcon = Icons.TruckIcon as iconProps;
export const TrashIcon = Icons.TrashIcon as iconProps;
export const ThreeSixtySolidIcon = Icons.ThreeSixtySolidIcon as iconProps;
export const ThreeSixtyInteriorRearSolidIcon =
  Icons.ThreeSixtyInteriorRearSolidIcon as iconProps;
export const ThreeSixtyInteriorFrontSolidIcon =
  Icons.ThreeSixtyInteriorFrontSolidIcon as iconProps;
export const ThreeSixtyExteriorSolidIcon =
  Icons.ThreeSixtyExteriorSolidIcon as iconProps;
export const TagIcon = Icons.TagIcon as iconProps;
export const StopwatchSolidIcon = Icons.StopwatchSolidIcon as iconProps;
export const StopIcon = Icons.StopIcon as iconProps;
export const SteeringWheelIcon = Icons.SteeringWheelIcon as iconProps;
export const StarIcon = Icons.StarIcon as iconProps;
export const StarSolidIcon = Icons.StarSolidIcon as iconProps;
export const StarHalfSolidIcon = Icons.StarHalfSolidIcon as iconProps;
export const Squares2x2Icon = Icons.Squares2x2Icon as iconProps;
export const SpeakerXMarkIcon = Icons.SpeakerXMarkIcon as iconProps;
export const SpeakerWaveIcon = Icons.SpeakerWaveIcon as iconProps;
export const ShieldSolidIcon = Icons.ShieldSolidIcon as iconProps;
export const ShieldCheckIcon = Icons.ShieldCheckIcon as iconProps;
export const SeatsIcon = Icons.SeatsIcon as iconProps;
export const ResetTimeIcon = Icons.ResetTimeIcon as iconProps;
export const QuestionMarkCircleIcon = Icons.QuestionMarkCircleIcon as iconProps;
export const QrCodeIcon = Icons.QrCodeIcon as iconProps;
export const ProfileCcwCircleArrowIcon =
  Icons.ProfileCcwCircleArrowIcon as iconProps;
export const PrinterIcon = Icons.PrinterIcon as iconProps;
export const PlusIcon = Icons.PlusIcon as iconProps;
export const PlusSmallIcon = Icons.PlusSmallIcon as iconProps;
export const PlusCircleIcon = Icons.PlusCircleIcon as iconProps;
export const PlayIcon = Icons.PlayIcon as iconProps;
export const PlayPauseIcon = Icons.PlayPauseIcon as iconProps;
export const PlayCircleIcon = Icons.PlayCircleIcon as iconProps;
export const Pin2Icon = Icons.Pin2Icon as iconProps;
export const PinSolidIcon = Icons.PinSolidIcon as iconProps;
export const PhotoIcon = Icons.PhotoIcon as iconProps;
export const PhoneIcon = Icons.PhoneIcon as iconProps;
export const PencilSquareIcon = Icons.PencilSquareIcon as iconProps;
export const PauseIcon = Icons.PauseIcon as iconProps;
export const PauseCircleIcon = Icons.PauseCircleIcon as iconProps;
export const PaperClipIcon = Icons.PaperClipIcon as iconProps;
export const PaperAirplaneIcon = Icons.PaperAirplaneIcon as iconProps;
export const PaintDropSolidIcon = Icons.PaintDropSolidIcon as iconProps;
export const PaintCanIcon = Icons.PaintCanIcon as iconProps;
export const OdometerSolidIcon = Icons.OdometerSolidIcon as iconProps;
export const NoSymbolIcon = Icons.NoSymbolIcon as iconProps;
export const MinusIcon = Icons.MinusIcon as iconProps;
export const MinusSmallIcon = Icons.MinusSmallIcon as iconProps;
export const MinusCircleIcon = Icons.MinusCircleIcon as iconProps;
export const MegaphoneIcon = Icons.MegaphoneIcon as iconProps;
export const MedalSolidIcon = Icons.MedalSolidIcon as iconProps;
export const MapPinIcon = Icons.MapPinIcon as iconProps;
export const MagnifyingGlassIcon = Icons.MagnifyingGlassIcon as iconProps;
export const MagnifyingGlassPlusIcon =
  Icons.MagnifyingGlassPlusIcon as iconProps;
export const MagnifyingGlassMinusIcon =
  Icons.MagnifyingGlassMinusIcon as iconProps;
export const LockOpenIcon = Icons.LockOpenIcon as iconProps;
export const LockClosedIcon = Icons.LockClosedIcon as iconProps;
export const LocationAreaIcon = Icons.LocationAreaIcon as iconProps;
export const ListBulletIcon = Icons.ListBulletIcon as iconProps;
export const LinkIcon = Icons.LinkIcon as iconProps;
export const InboxArrowDownIcon = Icons.InboxArrowDownIcon as iconProps;
export const ImagesIcon = Icons.ImagesIcon as iconProps;
export const HomeIcon = Icons.HomeIcon as iconProps;
export const HeartIcon = Icons.HeartIcon as iconProps;
export const HeartSolidIcon = Icons.HeartSolidIcon as iconProps;
export const HandThumbUpIcon = Icons.HandThumbUpIcon as iconProps;
export const HandThumbDownIcon = Icons.HandThumbDownIcon as iconProps;
export const GroundingSolidIcon = Icons.GroundingSolidIcon as iconProps;
export const GridSmallIcon = Icons.GridSmallIcon as iconProps;
export const GlobeAltIcon = Icons.GlobeAltIcon as iconProps;
export const GavelIcon = Icons.GavelIcon as iconProps;
export const FunnelIcon = Icons.FunnelIcon as iconProps;
export const FuelSolidIcon = Icons.FuelSolidIcon as iconProps;
export const ForkSpoonIcon = Icons.ForkSpoonIcon as iconProps;
export const FolderIcon = Icons.FolderIcon as iconProps;
export const FloppyDiskSolidIcon = Icons.FloppyDiskSolidIcon as iconProps;
export const FlagIcon = Icons.FlagIcon as iconProps;
export const FlagSolidIcon = Icons.FlagSolidIcon as iconProps;
export const FireIcon = Icons.FireIcon as iconProps;
export const FireSolidIcon = Icons.FireSolidIcon as iconProps;
export const FileSpreadsheetSolidIcon =
  Icons.FileSpreadsheetSolidIcon as iconProps;
export const FilePdfSolidIcon = Icons.FilePdfSolidIcon as iconProps;
export const FileExcelSolidIcon = Icons.FileExcelSolidIcon as iconProps;
export const EyeIcon = Icons.EyeIcon as iconProps;
export const EyeSlashIcon = Icons.EyeSlashIcon as iconProps;
export const ExclamationTriangleIcon =
  Icons.ExclamationTriangleIcon as iconProps;
export const ExclamationCircleIcon = Icons.ExclamationCircleIcon as iconProps;
export const EnvelopeIcon = Icons.EnvelopeIcon as iconProps;
export const EnterSolidIcon = Icons.EnterSolidIcon as iconProps;
export const EllipsisVerticalIcon = Icons.EllipsisVerticalIcon as iconProps;
export const EllipsisHorizontalIcon = Icons.EllipsisHorizontalIcon as iconProps;
export const DocumentIcon = Icons.DocumentIcon as iconProps;
export const DocumentTextIcon = Icons.DocumentTextIcon as iconProps;
export const ComputerDesktopIcon = Icons.ComputerDesktopIcon as iconProps;
export const DocumentDuplicateIcon = Icons.DocumentDuplicateIcon as iconProps;
export const DevicePhoneMobileIcon = Icons.DevicePhoneMobileIcon as iconProps;
export const DetailsIcon = Icons.DetailsIcon as iconProps;
export const DamagesSolidIcon = Icons.DamagesSolidIcon as iconProps;
export const CurrencyDollarIcon = Icons.CurrencyDollarIcon as iconProps;
export const CupIcon = Icons.CupIcon as iconProps;
export const CreditCardIcon = Icons.CreditCardIcon as iconProps;
export const ConditionReportSolidIcon =
  Icons.ConditionReportSolidIcon as iconProps;
export const Cog8ToothIcon = Icons.Cog8ToothIcon as iconProps;
export const CodeBracketIcon = Icons.CodeBracketIcon as iconProps;
export const CloudArrowUpIcon = Icons.CloudArrowUpIcon as iconProps;
export const ClockIcon = Icons.ClockIcon as iconProps;
export const ClipboardIcon = Icons.ClipboardIcon as iconProps;
export const ClipboardCheckIcon = Icons.ClipboardCheckIcon as iconProps;
export const ChevronUpIcon = Icons.ChevronUpIcon as iconProps;
export const ChevronUpDownIcon = Icons.ChevronUpDownIcon as iconProps;
export const ChevronRightIcon = Icons.ChevronRightIcon as iconProps;
export const ChevronLeftIcon = Icons.ChevronLeftIcon as iconProps;
export const ChevronDownIcon = Icons.ChevronDownIcon as iconProps;
export const CheckmarkSolidIcon = Icons.CheckmarkSolidIcon as iconProps;
export const CheckCircleIcon = Icons.CheckCircleIcon as iconProps;
export const ChatBubbleLeftIcon = Icons.ChatBubbleLeftIcon as iconProps;
export const ChatBubbleLeftRightIcon =
  Icons.ChatBubbleLeftRightIcon as iconProps;
export const ChartPieIcon = Icons.ChartPieIcon as iconProps;
export const CarSolidIcon = Icons.CarSolidIcon as iconProps;
export const CarSideIcon = Icons.CarSideIcon as iconProps;
export const CameraIcon = Icons.CameraIcon as iconProps;
export const CalendarIcon = Icons.CalendarIcon as iconProps;
export const BuildingOfficeIcon = Icons.BuildingOfficeIcon as iconProps;
export const BoltIcon = Icons.BoltIcon as iconProps;
export const BellSolidIcon = Icons.BellSolidIcon as iconProps;
export const Bars3Icon = Icons.Bars3Icon as iconProps;
export const Bars2Icon = Icons.Bars2Icon as iconProps;
export const BarCodeSolidIcon = Icons.BarCodeSolidIcon as iconProps;
export const BackToStartSolidIcon = Icons.BackToStartSolidIcon as iconProps;
export const ArrowsUpDownIcon = Icons.ArrowsUpDownIcon as iconProps;
export const ArrowsRightLeftIcon = Icons.ArrowsRightLeftIcon as iconProps;
export const ArrowsPointingOutIcon = Icons.ArrowsPointingOutIcon as iconProps;
export const ArrowsPointingInIcon = Icons.ArrowsPointingInIcon as iconProps;
export const ArrowUturnRightIcon = Icons.ArrowUturnRightIcon as iconProps;
export const ArrowUturnLeftIcon = Icons.ArrowUturnLeftIcon as iconProps;
export const ArrowUpTrayIcon = Icons.ArrowUpTrayIcon as iconProps;
export const ArrowUpOnSquareIcon = Icons.ArrowUpOnSquareIcon as iconProps;
export const ArrowTrendingUpIcon = Icons.ArrowTrendingUpIcon as iconProps;
export const ArrowTrendingDownIcon = Icons.ArrowTrendingDownIcon as iconProps;
export const ArrowTopRightOnSquareIcon =
  Icons.ArrowTopRightOnSquareIcon as iconProps;
export const ArrowSmallUpIcon = Icons.ArrowSmallUpIcon as iconProps;
export const ArrowSmallDownIcon = Icons.ArrowSmallDownIcon as iconProps;
export const ArrowRightOnRectangleIcon =
  Icons.ArrowRightOnRectangleIcon as iconProps;
export const ArrowPathIcon = Icons.ArrowPathIcon as iconProps;
export const ArrowLongRightIcon = Icons.ArrowLongRightIcon as iconProps;
export const ArrowDownTrayIcon = Icons.ArrowDownTrayIcon as iconProps;
export const AlarmSetSolidIcon = Icons.AlarmSetSolidIcon as iconProps;
export const AlarmClockSolidIcon = Icons.AlarmClockSolidIcon as iconProps;
export const AlarmAddSolidIcon = Icons.AlarmAddSolidIcon as iconProps;

export const SaveIcon = Icons.FloppyDiskSolidIcon as iconProps;
export const CancelIcon = Icons.NoSymbolIcon as iconProps;
export const CopyToClipboardIcon = Icons.DocumentDuplicateIcon as iconProps;
export const EditIcon = Icons.PencilSquareIcon as iconProps;
export const MapIcon = Icons.LocationAreaIcon as iconProps;
export const EmailIcon = Icons.EnvelopeIcon as iconProps;
export const FavouriteEnabledIcon = Icons.HeartSolidIcon as iconProps;
export const FavouriteDisabledIcon = Icons.HeartIcon as iconProps;
export const OpenInNewTabIcon = Icons.ArrowTopRightOnSquareIcon as iconProps;
